import React from 'react';
const pains = [{
  emoji: '😰',
  title: 'CONSTANT PRACTICE PLANNING',
  lines: ["Every week you're choosing drills, building progressions, organizing stations, and adapting sessions for different levels.", 'Then next week, you start all over again.']
}, {
  emoji: '⚠️',
  title: 'UNSURE WHAT COMES NEXT?',
  questions: ['What skill should I teach next?', 'Is this gymnast ready to progress?', 'Which drill should I use?', 'How do I manage different levels?'],
  lines: ['You know how to coach. You just need a clearer system.']
}, {
  emoji: '📚',
  title: 'EVERYTHING IS SCATTERED',
  lines: ['Drills. Videos. PDFs. Notes. Progressions. Practice ideas.', "You have the information—but it's everywhere."]
}, {
  emoji: '😩',
  title: 'TOO MUCH PREP. NOT ENOUGH COACHING.',
  lines: ["Planning, tracking, organizing and preparing shouldn't consume your week.", 'Spend less time building resources. More time coaching.']
}];
export function PainSection() {
  return <section className="py-8 px-4 bg-brand-cloud border-y border-brand-line" data-id="element-140" data-mp="3nkdzvdbwsx6t">
      <div className="max-w-4xl mx-auto" data-id="element-141" data-mp="5gcbaclq9zvi">
        <h2 className="text-2xl sm:text-3xl font-display font-extrabold text-center text-brand-ink mb-2 uppercase tracking-tight" data-id="element-142" data-mp="5f19gibuf271">
          Does This Sound Familiar?
        </h2>

        <p className="text-base sm:text-lg text-brand-slate font-medium text-center mb-6 max-w-2xl mx-auto leading-snug" data-id="element-143" data-mp="38xb010046cgb">
          You love coaching gymnastics—but planning, organizing and preparing
          every practice takes hours.
        </p>

        <div className="grid sm:grid-cols-2 gap-3" data-id="element-144" data-mp="3dvmc7hdvsz1p">
          {pains.map((pain, i) => <div key={i} className="bg-white p-4 rounded-xl border border-brand-line shadow-sm flex flex-col items-center text-center sm:items-start sm:text-left sm:flex-row gap-3" data-id="element-145" data-mp="3dtt0hnoevomu" data-mpi={i}>
              <div className="text-3xl shrink-0" data-id="element-146" data-mp="p4bxp8c8whoo">{pain.emoji}</div>
              <div data-id="element-147" data-mp="p1zj955p4pgd">
                <h3 className="text-base font-bold text-brand-navy mb-1 uppercase tracking-wide leading-tight" data-id="element-148" data-mp="u2n7jj2jis6w">
                  {pain.title}
                </h3>
                {pain.questions && <ul className="text-brand-slate text-sm font-semibold leading-snug mb-1.5 space-y-0.5 list-disc list-inside marker:text-brand-blue" data-id="element-149" data-mp="12uywt1lx49la">
                    {pain.questions.map((q, qi) => <li key={qi} data-id="element-150" data-mp="b3j2smi17kl1" data-mpi={qi}>{q}</li>)}
                  </ul>}
                <div className="space-y-1" data-id="element-151" data-mp="f54j6htrygzz">
                  {pain.lines.map((line, li) => <p key={li} className="text-brand-slate text-sm font-medium leading-snug" data-id="element-152" data-mp="k58ttr804hia" data-mpi={li}>
                      {line}
                    </p>)}
                </div>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}